import taskmanAxios from '../helpers/axios'
import {
    API_NOTIFICATIONS_LIST_URL,
    API_NOTIFICATIONS_UNREAD_COUNT_URL,
    API_NOTIFICATIONS_READ_ALL_URL,
    API_MAKE_NOTIFICATION_READ_URL,
    API_MAKE_NOTIFICATION_URL,
} from "../constants/api.constant";
import { NotificationListI, NotificationReadI, NotificationUnreadCountI } from "../types";

export default class NotificationService {
    private static extractNotifications(data: any): NotificationReadI[] {
        if (Array.isArray(data)) {
            return data
        }

        if (Array.isArray(data?.notifications)) {
            return data.notifications
        }

        if (Array.isArray(data?.items)) {
            return data.items
        }

        if (Array.isArray(data?.results)) {
            return data.results
        }

        if (Array.isArray(data?.data)) {
            return data.data
        }

        return []
    }

    static async list(params?: {
        skip?: number;
        limit?: number;
        unread_only?: boolean;
    }): Promise<NotificationListI> {
        return await taskmanAxios.get(API_NOTIFICATIONS_LIST_URL, { params })
            .then(response => ({
                notifications: this.extractNotifications(response.data),
                total: response.data?.total ?? 0,
                unread_count: response.data?.unread_count ?? 0,
            }))
            .catch(e => Promise.reject(e));
    }

    static async unreadCount(): Promise<number> {
        return await taskmanAxios.get(API_NOTIFICATIONS_UNREAD_COUNT_URL)
            .then(response => response.data?.unread_count ?? 0)
            .catch(e => Promise.reject(e));
    }

    static async markRead(notificationId: string | number): Promise<NotificationReadI> {
        return await taskmanAxios.post(API_MAKE_NOTIFICATION_READ_URL(notificationId), {})
            .then(response => {
                window.dispatchEvent(new Event('cor-task-notifications-changed'))
                return response.data
            })
            .catch(e => Promise.reject(e));
    }

    static async markAllRead(): Promise<NotificationUnreadCountI> {
        return await taskmanAxios.post(API_NOTIFICATIONS_READ_ALL_URL, {})
            .then(response => {
                window.dispatchEvent(new Event('cor-task-notifications-changed'))
                return response.data
            })
            .catch(e => Promise.reject(e));
    }

    static async remove(notificationId: string | number) {
        return await taskmanAxios.delete(API_MAKE_NOTIFICATION_URL(notificationId))
            .then(response => {
                window.dispatchEvent(new Event('cor-task-notifications-changed'))
                return response.data
            })
            .catch(e => Promise.reject(e));
    }
}
